export const completionOnce = (callback?: () => void) => {
  if (!callback) return undefined;
  let completed = false;
  return () => {
    if (completed) return;
    completed = true;
    callback();
  };
};
